import ExternalLink from '../components/ExternalLink';
import PageHeader from '../components/PageHeader';
import useDocumentMeta from '../hooks/useDocumentMeta';
import { experience, pageMeta } from '../data/site';
import styles from './Work.module.scss';

function Work() {
  useDocumentMeta(pageMeta['/work']);

  return (
    <>
      <PageHeader
        eyebrow="Experience"
        title="Work"
        intro="Teams and products I have built front-end interfaces for, most recent first."
      />

      {/* An ordered list, because the sequence carries meaning. */}
      <ol className={styles.list}>
        {experience.map(({ id, role, company, location, href, note }) => (
          <li key={id} className={styles.item}>
            <h2 className={styles.role}>{role}</h2>

            <p className={styles.meta}>
              {href ? (
                <ExternalLink href={href} className={styles.company}>
                  {company}
                </ExternalLink>
              ) : (
                <span className={styles.company}>{company}</span>
              )}

              {note && <span className={styles.note}>({note})</span>}

              <span className={styles.separator} aria-hidden="true">
                ·
              </span>

              <span className={styles.location}>{location}</span>
            </p>
          </li>
        ))}
      </ol>
    </>
  );
}

export default Work;
